import { throwError as observableThrowError } from "rxjs";

import { catchError, map } from "rxjs/operators";
import { ErrorHandler, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { environment } from "../../environments/environment";

@Injectable()
export class DashboardDisplayService {
  constructor(
    public http: HttpClient,
    private rollbarErrorHandler: ErrorHandler
  ) {}

  getDataConfigs() {
    let url = `${environment.kpiServiceApi}/kpis/dataconfigurations`;
    return this.http
      .get(url, { withCredentials: true })
      .pipe(catchError((err) => this.handleError(err)));
  }

  getCustAggGroups(aggGroupType) {
    let url = `${environment.kpiServiceApi}/kpis/aggregategroups/${aggGroupType}`;
    return this.http
      .get(url, { withCredentials: true })
      .pipe(catchError((err) => this.handleError(err)));
  }

  addorUpdateCustAggGroup(
    kpiId,
    aggGroupId,
    standardAggGroupId,
    tableName,
    visibility
  ) {
    if (aggGroupId) {
      return this.updateCustomerAggregateGroup(kpiId, aggGroupId, visibility);
    } else {
      return this.addCustomerAggregateGroup(
        kpiId,
        standardAggGroupId,
        tableName,
        visibility
      );
    }
  }

  updateCustomerAggregateGroup(kpiId, aggGroupId, visibility) {
    let url = `${environment.kpiServiceApi}/kpis/${kpiId}/aggregategroups/${aggGroupId}`;
    let body = {
      visible: visibility,
    };
    return this.http
      .patch(url, body, { withCredentials: true })
      .pipe(catchError((err) => this.handleError(err)));
  }

  addCustomerAggregateGroup(kpiId, standardAggGroupId, tableName, visibility) {
    let url = `${environment.kpiServiceApi}/kpis/${kpiId}/aggregategroups`;
    let body = {
      visible: visibility,
      standardAggregateGroupId: standardAggGroupId,
      tableName: tableName,
    };
    return this.http
      .post(url, body, { withCredentials: true })
      .pipe(catchError((err) => this.handleError(err)));
  }

  handleError(error) {
    console.error("error status: " + error.status);
    this.rollbarErrorHandler.handleError(error);
    return observableThrowError(error.status);
  }
}
